"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _styledComponents = require("styled-components");
var Styled = _interopRequireWildcard(require("./styles/Logo.style"));
var _constants = require("../../../../constants");
var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Logo = function Logo(_ref) {
  var dataSelectorPrefix = _ref.dataSelectorPrefix;
  var theme = (0, _styledComponents.useTheme)();
  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
    logo = _ref2.logo,
    interactionHandler = _ref2.interactionHandler,
    appearance = _ref2.appearance,
    topNavigationTheme = _ref2.topNavigationTheme;
  var inverseLogo = topNavigationTheme.appearance[appearance].mainBar.inverseLogo;
  var inverseBrandLogo = theme.inverseBrandLogo,
    brandLogo = theme.brandLogo;
  var clickHandler = function clickHandler(event) {
    interactionHandler(event, _constants.DataKeys.Logo);
    if (!logo.onClick) return;
    logo.onClick();
  };
  return /*#__PURE__*/_react["default"].createElement(Styled.LogoWrapper, {
    id: logo.id,
    label: logo.text,
    href: logo.href,
    customRouterProps: logo.customRouterProps,
    onClick: clickHandler,
    onMouseDown: logo.onMouseDown,
    onMouseUp: logo.onMouseUp,
    onTouchStart: logo.onTouchStart,
    onTouchEnd: logo.onTouchEnd,
    dataAttributes: logo.dataAttributes,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, inverseLogo ? inverseBrandLogo() : brandLogo());
};
Logo.displayName = "Logo";
var _default = Logo;
exports["default"] = _default;